import type { TruncationMode } from '../../typography/text-ellipsis/TextEllipsis.js';
import { TRUNCATION_MODE } from '../core/constants.js';
import type { SankeyState } from './types/sankey-state.js';

export const DISPLAY_NAME = 'SankeyChart';

export const SANKEY_CHART_ARIA_LABEL = 'Sankey Chart';

export const INITIAL_SANKEY_STATE: SankeyState = {
  hovered: undefined,
  selected: undefined,
};

export const DEFAULT_TRUNCATION_MODE: TruncationMode = TRUNCATION_MODE.Middle;

export const DEFAULT_CHART_HEIGHT = 300;

/** d3-sankey node geometry defaults (visual tuning deferred). */
export const DEFAULT_NODE_WIDTH = 20;
export const DEFAULT_NODE_PADDING = 20;
export const LAYOUT_MARGIN = 4;

export const FALLBACK_NODE_COLOR = '#888888';
export const NODE_BORDER_RADIUS = 4;

export const INSIDE_LABEL_PADDING = 4;
export const INSIDE_LABEL_WIDTH_RATIO = 0.8;
export const MAX_SIDE_LABEL_WIDTH_RATIO = 0.2;

export const DEFAULT_LINK_OPACITY = 0.3;
export const HIGHLIGHT_LINK_OPACITY = 0.6;
export const DIM_CANVAS_ALPHA = 0.5;

export const COLUMN_HEADER_HEIGHT = 40;
export const COLUMN_LABEL_HORIZONTAL_PADDING = 16;
